// Formats a product's `released_at` date ("2026-05-01", a date-only value from Algolia) into a
// "Launches May 2026" label for the source-directory cards. The date-only string is anchored to
// local midnight ("T00:00:00") so the month never shifts backwards under a negative UTC offset.
// Returns null for missing/invalid input so callers can render nothing rather than a bad label.
export default function launchesLabel(releasedAt) {
  if (!releasedAt) return null;

  const date = new Date(`${releasedAt}T00:00:00`);
  if (Number.isNaN(date.getTime())) return null;

  return `Launches ${date.toLocaleDateString("en-US", { month: "long", year: "numeric" })}`;
}
